/**
 * Класс для работы с куками
 * constructor
 */
function CookieHelper() {
    /** let string maxCookieDate - Максимальная дата для кук (практически бесконечная) */
    const maxCookieDate = '31 Dec 9999 23:59:59 GMT';

    /** let string checkedForCartAddCookie - Символьный код для куки выбранных для добавления в корзину товаров */
    const checkedForCartAddCookie = 'prepared_for_cart_products';

    /**
     * Получаем максимальную дату для куки
     *
     */
    this.getMaxCookieDate = () => {
        return maxCookieDate;
    };

    /**
     * Получаем символьный код куки для выбраных товаров для добавления в корзину
     */
    this.getCheckedForCartAddCookie = () => {
        return checkedForCartAddCookie;
    };

    /**
     * Записываем выбранные для добавления в корзину товары в куку
     * @param chosenProducts declaration
     */

    this.setCheckedProductsCookie = chosenProducts => {
        document.cookie = `${checkedForCartAddCookie}=${JSON.stringify(
            chosenProducts
        )}; path=/; expires=${maxCookieDate}`;
    };

    /**
     * Очищаем выбранные для добавления в корзину товары
     */
    this.clearCheckedProductsCookie = () => {
        this.setSimpleCookie(checkedForCartAddCookie, {});
    };

    this.setSimpleCookie = (name, value) => {
        let strValue = value;
        if (typeof value == 'object') {
            strValue = JSON.stringify(value);
        }

        let cookieString = `${name}=${escape(strValue)}`;
        cookieString += `; expires=${maxCookieDate}`;
        cookieString += '; path=/';

        document.cookie = cookieString;
    };

    this.getSimpleCookie = name => {
        const results = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);

        if (!results) {
            return null;
        }

        const value = unescape(results[2]);
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    };

    /**
     * Получаем значение куки по ее названию
     */

    this.getCookie = cookieName => {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
}

export default CookieHelper;
